import {useState} from "react";
import {useGetCustomerProducts} from "../../../../react-query-hooks/products";
import {FullPageLoader} from "../../../full-page-loader";
import {Alert, Space, Spin} from "antd";
import {EmptyState} from "../../../empty-state";
import {LoadingSpinner} from "../../../icons/icons";
import {CustomerDashboardProductCard} from "../card";
import {CustomPagination} from "../../../pagination";

export function CustomerProductListPage() {
  const [page, setPage] = useState(1);
  const getCustomerProductsQuery = useGetCustomerProducts(page);

  if (getCustomerProductsQuery.isLoading) {
    return <FullPageLoader />;
  }
  if (getCustomerProductsQuery.isError) {
    return (
      <Alert
        message="Error"
        description={getCustomerProductsQuery.error.message}
        type="error"
        showIcon
      />
    );
  }

  const hasProduct = getCustomerProductsQuery.data.data.products.length > 0;

  return (
    <div>
      {hasProduct ? (
        <div>
          <Spin
            spinning={getCustomerProductsQuery.isFetching}
            tip="Updating..."
            indicator={LoadingSpinner}
          >
            <Space direction="vertical" size={40} style={{display: "flex"}}>
              {getCustomerProductsQuery.data.data.products.map((product) => (
                <CustomerDashboardProductCard product={product} key={product.id} />
              ))}
            </Space>
          </Spin>
          <CustomPagination
            isPreviousData={getCustomerProductsQuery.isPreviousData}
            page={page}
            paginationMeta={getCustomerProductsQuery.data.meta}
            setPage={setPage}
          />
        </div>
      ) : (
        <EmptyState
          message={
            "You do not have any product at the moment. Buy a new product to get started."
          }
        />
      )}
    </div>
  );
}
